import { localePath } from "@/helper/urlHelper";
import { useRouter } from "next/router";
import { AnchorHTMLAttributes, ReactNode } from "react";

type DocumentLinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  "href" | "children"
> & {
  href: string;
  children: ReactNode;
};

// Client transitions keep t() on the default locale. These links load the
// locale URL as a document so getServerSideProps renders that language.
export function DocumentLink({ href, children, ...props }: DocumentLinkProps) {
  const { locale } = useRouter();
  return (
    <a href={localePath(locale, href)} {...props}>
      {children}
    </a>
  );
}
